var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "spinner-bg" } }, [
    _c("div", { attrs: { id: "default-spinner" } }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !!_vm.progress,
              expression: "!!progress"
            }
          ],
          attrs: { id: "spinner-progress" }
        },
        [_vm._v(_vm._s(_vm.progress))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "loader" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }